<div class="flex flex-col h-screen overflow-hidden">
  <!-- Header principal -->
  <app-head-menu />

  <!-- Contenedor principal -->
  <main class="flex flex-1 overflow-hidden">
    <!-- Sidebar -->
    <aside class="sidebar flex-shrink-0">
      <ul class="sidebar-menu">
        <a class="sidebar-item" routerLink="/provider" routerLinkActive="active-link">
          <span class="material-symbols-outlined sidebar-icon">hand_package</span>
          <span class="sidebar-text">Proveedores</span>
        </a>
        <a class="sidebar-item" routerLink="/register" routerLinkActive="active-link">
          <span class="material-symbols-outlined sidebar-icon">assignment</span>
          <span class="sidebar-text">Registro</span>
        </a>
        <a class="sidebar-item" routerLink="/bill" routerLinkActive="active-link">
          <span class="material-symbols-outlined sidebar-icon">request_quote</span>
          <span class="sidebar-text">Facturas</span>
        </a>
        <a class="sidebar-item" routerLink="/quotation" routerLinkActive="active-link">
          <span class="material-symbols-outlined sidebar-icon">receipt_long</span>
          <span class="sidebar-text">Cotizaciones</span>
        </a>
        <a class="sidebar-item" routerLink="/purchase" routerLinkActive="active-link">
          <span class="material-symbols-outlined sidebar-icon">orders</span>
          <span class="sidebar-text">Ordenes de compra</span>
        </a>
      </ul>
    </aside>

    <!-- Contenido de rutas -->
    <section class="flex-1 overflow-y-auto bg-white">
      <router-outlet />
    </section>
  </main>
</div>
